module.exports = __webpack_public_path__ + "static/media/11ty.b0be342c.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/11ty.png
// module id = 969
// module chunks = 0